import React from "react";
import { Box } from "@mui/material";

const MainReusableBox = ({ children, sx, ...props }) => {
  return (
    <Box
      sx={{
        padding: 4, // Default padding
        backgroundColor: "background.paper", // Default background color
        borderRadius: 5, // Default border radius
        boxShadow: 2, // Default box shadow
        ...sx, // Allow custom styles to override default styles
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default MainReusableBox;
